import { AsyncPageRender } from '@components/AsyncComponent';
import { ProtectedRoute } from '@components/Layout/ProtectedRoute';
import { pageModule } from '@components/pageModule';
import React from 'react';
import { Route } from 'react-router';

export const routes$ = {
    Index: AsyncPageRender(() => pageModule(import('./Index'))),
    Edit: AsyncPageRender(() => pageModule(import('./Edit'))),
};

function Router() {
    return (
        <>
            <Route exact path={'/operations/products'} component={ProtectedRoute(routes$.Index)} />
            <Route exact path={'/operations/products/:tab'} component={ProtectedRoute(routes$.Index)} />
            <Route
                exact
                path={'/operations/products/packages/:package/edit'}
                component={ProtectedRoute(routes$.Edit)}
            />
            <Route
                exact
                path={'/operations/products/packages/:package/edit/:tab'}
                component={ProtectedRoute(routes$.Edit)}
            />
        </>
    );
}

export default Router;
